import * as React from 'react';
/**
 *
 * Original name: print
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=40546%3A10886
 *
 */
export const PrintPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24 16h16v6.015H24V16Zm-4 6.015V12h24v10.015h10v18.702a6 6 0 0 1-6 6h-4v5.302H20v-5.302h-4a6 6 0 0 1-6-6V22.015h10Zm0 4h-6v14.702a2 2 0 0 0 2 2h4V32.019h24v10.698h4a2 2 0 0 0 2-2V26.015h-6v.002H20v-.002ZM40 48.02H24v-12h16v12Z", fill: "currentColor" })));
